import { render, staticRenderFns } from "./SortByContentOptions.vue?vue&type=template&id=4d3f382c&scoped=true&"
import script from "./SortByContentOptions.vue?vue&type=script&lang=js&"
export * from "./SortByContentOptions.vue?vue&type=script&lang=js&"
import style0 from "./SortByContentOptions.vue?vue&type=style&index=0&id=4d3f382c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f382c",
  null
  
)

export default component.exports